import { Modal, Row, Col, Form } from 'react-bootstrap'
import { useEffect, useState, useRef } from "react";
import { Button } from "react-bootstrap";
import { InputGroup } from 'react-bootstrap';
import { useApiClient } from '../../ApiService/useApiClient';

const AddEditStaff = ({show, setShowAddEdit, data, setdata, isAdmin}) => {
    const api = useApiClient();
    const formDefault = {
        opened: true,
        modalTitle: "Add New Staff"
    }
    const [formModal, setFormModal] = useState(formDefault);
    const [error, setError] = useState('');
    const modalForm = useRef(null);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        setFormModal({ ...formModal, opened: show, action: 'add' });
    }, [show]);

    function closeFormModal() {
        setFormModal({ ...formModal, opened: false });
        setShowAddEdit(false);
        setError('');
    }

    // Simple regex-based validation
    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }
    function isValidPhone(phone) {
        // Accepts numbers with optional +, spaces, dashes, and dots, at least 10 digits
        return /^(\+?\d{1,2}\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4,}$/.test(phone);
    }

    function handleFormSubmit(event) {
        event.preventDefault();
        setError('');

        // Get values
        const AgentFname = modalForm.current.querySelector('#AgentFname').value.trim();
        const AgentLname = modalForm.current.querySelector('#AgentLname').value.trim();
        const EmailId = modalForm.current.querySelector('#EmailId').value.trim();
        const MobileNo = modalForm.current.querySelector('#MobileNo').value.trim();
        const Password = modalForm.current.querySelector('#Password').value.trim();

        // Check for empty fields
        if (!AgentFname || !AgentLname || !EmailId || !MobileNo || !Password) {
            setError('All fields are required.');
            return;
        }
        // Email validation
        if (!isValidEmail(EmailId)) {
            setError('Please enter a valid email address.');
            return;
        }
        // Phone validation
        if (!isValidPhone(MobileNo)) {
            setError('Please enter a valid phone number.');
            return;
        }

        // Prepare form data
        const frmFormData = new FormData();
        frmFormData.append("AgentFname", AgentFname);
        frmFormData.append("AgentLname", AgentLname);
        frmFormData.append("EmailId", EmailId);
        frmFormData.append("MobileNo", MobileNo);
        frmFormData.append("Password", Password);
        frmFormData.append("IsAdmin", isAdmin);

        const sURL = "HMCareStaff/staff/add/";
      
        api.post(sURL, frmFormData)
            .then((Response) => {
                let updatedDataObj = Response.data;
                setdata([...data, updatedDataObj]);
                closeFormModal();
            })
            .catch(error => {
                if (error.response) {
                    setError(error.response.data.detail	|| 'An error occurred');
                }else{
                    setError('Failed to add staff. Please try again.');
                }
                //console.log({ error });
            });
    }

    return (
        <Modal show={formModal.opened} onHide={closeFormModal} size="lg">
            <Form ref={modalForm} onSubmit={handleFormSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title className="event-title" as="h4">{formModal.modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <p style={{ color: 'red', fontWeight: 'bold' }}>{error}</p>}
                    <Row className="g-gs">
                        <Col xs="6">
                            <Form.Group>
                                <Form.Label>First Name</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control id="AgentFname" type="text" placeholder="First Name(s)" required />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col xs="6">
                            <Form.Group>
                                <Form.Label>Last Name</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control id="AgentLname" type="text" placeholder="Surname" required />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col xs="6">
                            <Form.Group>
                                <Form.Label>Email Address</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control id="EmailId" type="email" placeholder="Email Address" required />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col xs="6">
                            <Form.Group>
                                <Form.Label>Password</Form.Label>
                                
                                <div className="form-control-wrap"><InputGroup>
                                    <Form.Control id="Password" type={showPassword ? "text" : "password"} placeholder="Password" required />
                                    <Button
                                variant="outline-secondary"
                                onClick={() => setShowPassword((v) => !v)}
                                tabIndex={-1}
                            >
                                {showPassword ? "🙈" : "👁️"}
                            </Button> </InputGroup>
                                </div>
                               
                            </Form.Group>
                        </Col>
                        <Col xs="6">
                            <Form.Group>
                                <Form.Label>Mobile Number</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control id="MobileNo" type="text" placeholder="Mobile" required />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={closeFormModal}>Discard</Button>
                    {formModal.action === 'add' && <Button variant="primary" type="submit">Add User</Button>}
                    {formModal.action === 'edit' && <Button variant="primary" type="submit">Update User</Button>}
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default AddEditStaff
